import { REGEX_CONSTANT } from "../../../../constant/regexConstant";

export const validUser = (namespace, data, translate) => {
  let error = {};

  switch (namespace) {
    case "nik":
      if (data.length > 20) {
        error[namespace] = translate("Field cannot be less than 1 and more than 20", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (data && !REGEX_CONSTANT.NIK.test(data)) {
        error[namespace] = translate("Invalid Format", {
          field: translate("Role ID"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "country_id":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "district_id":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "sub_district_id":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "urban_village_id":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "address":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (data.length > 100 || data.length <= 1) {
        error[namespace] = translate("Field cannot be less than 1 and more than 100", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "neighbourhood":
      // if (!data) {
      //   error[namespace] = translate("COMMON:REQUIRE", {
      //     field: translate("CUSTOMER:ADDITIONAL_NAME"),
      //   });
      // } else 
      if (data &&(data.length > 3 || data.length <3)) {
        error[namespace] = translate("Field cannot be less than 3", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      }else if (!REGEX_CONSTANT.INTEGER.test(data)) {
        error[namespace] = translate("Invalid format", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "hamlet":
      // if (!data) {
      //   error[namespace] = translate("COMMON:REQUIRE", {
      //     field: translate("CUSTOMER:ADDITIONAL_NAME"),
      //   });
      // } else 
      if (data &&(data.length > 3 || data.length <3)) {
        error[namespace] = translate("Field cannot be less than 3", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      }else if (!REGEX_CONSTANT.INTEGER.test(data)) {
        error[namespace] = translate("Invalid format", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "postal_code_id":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
      case "province_id":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;

    default:
      break;
  }
  return error;
};
